import { createSlice } from '@reduxjs/toolkit'

export const NAME = 'credit-request-quotes'

const initialState = {
  textFilter: '',
  quotes: [],
}

const { actions, reducer } = createSlice({
  name: NAME,
  initialState,
  reducers: {
    setQuotes: (state, { payload: quotes }) => {
      state.quotes = quotes
    },
    setTextFilter: (state, { payload: textFilter }) => {
      state.textFilter = textFilter
    },
    reset: () => ({
      ...initialState,
    }),
  },
})

export const { setQuotes, setTextFilter, reset } = actions

export default reducer
// @ts-ignore
const getState = state => state[NAME]
// @ts-ignore
export const getQuotes = state => getState(state).quotes
// @ts-ignore
export const getOpenQuotes = state => getQuotes(state).filter(quote => !quote.order?.ecomOrderId)
// @ts-ignore
export const getQuote = (state, id) => getQuotes(state).find(order => order.id === id)
